import Warning from "../1elements/Icons/js/Warning"
import {reExportedColors, Text} from "../1elements"
import Box from '@mui/material/Box'


/**　
 * UI Component to show when the user does not have permission to see the data.
 */
export default function AuthorizationError({className}){
    return(
        <Box className={className} sx={{
            alignItems: 'center',
            background: reExportedColors.LIGHT_GREY,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            padding: '50px'
        }}>
            <Warning style={{ marginBottom: '20px', maxHeight: '70px', maxWidth: '70px' }} />
            <Text type="locationViewHeader">An error has occurred.</Text>
            <Text type="locationViewText">Missing authorization, please contact your administrator</Text>
        </Box>
    )
}
